import { ALL_LOCATIONS_QUERY } from "../../../graphql/Locations/Locations.graphql";
import { ALL_ROUTES_VIEW_QUERY } from "../../../graphql/Routes/Routes.graphql";
import { ALL_ORDERS_VIEW_QUERY } from "../../../graphql/Orders/Orders.graphql";

const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

export default {
  name: "Dispatch Processing",
  label: "Dispatch",
  icon: "map-marker-alt",
  permissions: ["DISP", "SCH"],
  active: location => location.pathname.includes("dispatch"),
  links: [
    {
      name: "Setup",
      links: [
        {
          name: "Drivers",
          to: "/hr/employees"
        },
        {
          name: "Locations",
          to: "/dispatch/locations",
          query: ALL_LOCATIONS_QUERY,
          filters: "LOCATION_FILTERS"
        },
        {
          name: "Routes",
          to: "/dispatch/routes",
          query: ALL_ROUTES_VIEW_QUERY,
          filters: "ROUTE_FILTERS"
        },
        {
          name: "Vehicles",
          to: "/fleet/vehicles"
        }
      ]
    },
    {
      name: "Dispatch & Scheduling",
      links: [
        {
          name: "Orders",
          to: "/dispatch/orders",
          query: ALL_ORDERS_VIEW_QUERY,
          filters: "ORDER_FILTERS"
        },
        {
          name: "Order Scheduling",
          to: "/dispatch/scheduling"
        },
        {
          name: "Order Dispatching",
          to: "/dispatch/order-dispatching"
        }
        // {
        //   name: "Archived Orders",
        //   to: "/dispatch/order-archive"
        // }
      ]
    },
    {
      name: "ELD Processing",
      links: [
        {
          name: "Booked",
          to: "/dispatch/ELD/booked"
        },
        {
          name: "Exported",
          to: "/dispatch/ELD/exported"
        },
        {
          name: "Imported",
          to: "/dispatch/ELD/imported"
        },
        {
          name: "Verified",
          to: "/dispatch/ELD/verified"
        }
      ]
    },
    {
      name: "Order History",
      links: [
        {
          name: "Order History",
          to: "/finance/order-history"
        }
      ]
    },
    {
      name: "Dispatch Reports",
      links: [
        {
          name: "Daily Pick-up Dispatch Sheet",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=DailyPickupDispatchSheet`
        },
        {
          name: "Daily Pickup/Delivery Schedule",
          href: ({ user }) =>
            user?.FirstName && user?.LastName
              ? `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=DailyPickupDispatchSheetByCustomer&Param=User&ParamValue=${`${user.FirstName} ${user.LastName}`}`
              : `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=DailyPickupDispatchSheetByCustomer`
        },
        // {
        //   name: "Daily Pickup By Time",
        //   href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=DailyPickupDispatchSheetByTime`
        // },
        {
          name: "Daily Driver Schedule",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Daily%20Schedule`
        },
        {
          name: "Daily Grid Mail",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Daily%20Grid%20Mail%20Report`
        },
        {
          name: "Daily Grid Schedule",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=GridSchedule`
        },
        {
          name: "Shipment Control Log",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Daily%20Shipment%20Control`
        },
        {
          name: "Historical Register",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=HistoricalRegister`
        },
        {
          name: "Trailer Pressure History",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Trailer%20Pressure%20History`
        },
        {
          name: "Driver Work History",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Driver%20Work%20History`
        }
      ]
    }
  ]
};
